import { render } from "./ExamView.vue?vue&type=template&id=9996cd70&scoped=true"
import script from "./ExamView.vue?vue&type=script&lang=js"
export * from "./ExamView.vue?vue&type=script&lang=js"

import "./ExamView.vue?vue&type=style&index=0&id=9996cd70&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9996cd70"]])

export default __exports__